import { FaIcon } from '@ifixit/ui/components/icon';
import {
   DropdownMenu,
   DropdownMenuContent,
   DropdownMenuItem,
   DropdownMenuTrigger,
} from '@ifixit/ui/components/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@ifixit/ui/components/tooltip';
import { cn } from '@ifixit/ui/lib/utils';
import { TiptapButton, tiptapButtonClassName } from '../TiptapButton';
import { refocusOnClose } from './refocus_on_close';
import { useEditorContext, useEditorSelector } from '../../editor_context';
import { _js } from '@ifixit/utils/localize';

const gridModes = {
   columns: _js('Columns'),
   rows: _js('Rows'),
};

const GridToggleButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('grid'),
      isDisabled: !editor.can().toggleGrid(null),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleGrid(null).run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="grid" />}
         title={_js('Insert grid layout')}
      />
   );
};

export function GridDropdown() {
   return (
      <div className="inline-flex">
         <GridToggleButton />
         <GridDropdownMenu />
      </div>
   );
}

function GridDropdownMenu() {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   const label = _js('Choose grid layout');

   const handleOpenChange = refocusOnClose(editor);

   return (
      <Tooltip>
         <DropdownMenu onOpenChange={handleOpenChange}>
            <TooltipTrigger asChild>
               <DropdownMenuTrigger asChild>
                  <button type="button" aria-label={label} className={cn(tiptapButtonClassName)}>
                     <FaIcon name="chevron-down" />
                  </button>
               </DropdownMenuTrigger>
            </TooltipTrigger>
            <DropdownMenuContent align="start">
               {Object.entries(gridModes).map(([mode, modeLabel]) => {
                  const columns = mode === 'columns' ? 2 : null;
                  // Decide at click time: this render is not tied to
                  // transactions, so isActive read here would go stale.
                  const onSelect = () => {
                     const chain = editor.chain().focus();
                     (editor.isActive('grid')
                        ? chain.setGridMode(columns)
                        : chain.toggleGrid(columns)
                     ).run();
                  };
                  return (
                     <DropdownMenuItem key={mode} onSelect={onSelect}>
                        {modeLabel}
                     </DropdownMenuItem>
                  );
               })}
            </DropdownMenuContent>
         </DropdownMenu>
         <TooltipContent side="top" align="start">
            {label}
         </TooltipContent>
      </Tooltip>
   );
}
